module.exports = __webpack_public_path__ + "assets/img/photos.bd84ec62.png";